module.exports = __webpack_public_path__ + "img/logo-paypal.cb1e1e2f.png";